(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["optic-gift-date"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('optic-gift-date')) {
    customElements.define('optic-gift-date', class extends HTMLElement {
      connectedCallback() {
        this.date = this.querySelector('time');
        if (!this.date) return;

        this.updateDate();
        this.timer = window.setInterval(() => this.updateDate(), 60_000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      updateDate() {
        const today = new Date();
        const locale = this.dataset.locale || document.documentElement.lang || 'fr';

        this.date.textContent = new Intl.DateTimeFormat(locale, {
          day: 'numeric',
          month: 'long'
        }).format(today);
        this.date.dateTime = [
          today.getFullYear(),
          String(today.getMonth() + 1).padStart(2, '0'),
          String(today.getDate()).padStart(2, '0')
        ].join('-');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
